package pl.decks.chartjs.legend

import pl.decks.chartjs.model.JSEnum

@Suppress("unused")
enum class LegendAlign(override val jsValue: String) : JSEnum {
    Start("start"),
    Center("center"),
    End("end"),
}
